import { TOUR_PRIVACY } from '../constants/TourPrivacy.const';
import { USER_ROLES } from '../constants/UserRoles.const';
import firestoreService from '../services/FireStore.service';

const Tours = firestoreService.collection("v2_tours");

export const TourService = () => {

}

export const getTeamTours = (members) => {

    return Tours
        // .where('privacy', '==', TOUR_PRIVACY.PUBLIC)
        .where('createdBy.uid', 'in', members)
        .get()
        .then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => doc.data());
            console.log('data', data);
            return data;
        }).catch((error) => {
            Promise.reject(error);
        })
}

export const getAllTours = (setData) => {

    return Tours
        .where('privacy', '==', TOUR_PRIVACY.PUBLIC)
        .get()
        .then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => doc.data());
            console.log('data', data);
            return data;
        }).catch((error) => {
            Promise.reject(error);
        })
}

export const getAllToursByAccess = (user) => {

    return Tours
        .get()
        .then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => doc.data());
            console.log('data all tours', data);
            // return data;

            // Filter tours by access
            const filteredTours = data.filter(t => {
                if (
                    user.uid === t.createdBy.uid ||
                    user.userRole === USER_ROLES.ADMIN
                ) {
                    return true
                } else {
                    if (t.privacy && t.privacy === TOUR_PRIVACY.PUBLIC) {
                        return true
                    } else {
                        return false
                    }
                }
            })
            console.log('filteredTours', filteredTours)
            return filteredTours;


        }).catch((error) => {
            Promise.reject(error);
        })
}

export const getMyTours = (user) => {

    return Tours
        .where("createdBy.uid", "==", user.uid)
        .get()
        .then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => doc.data());
            console.log('data', data);
            return data;
        }).catch((error) => {
            Promise.reject(error);
        })
}

export const createTour = (data) => {

    return Tours
        .doc(data.id)
        .set(data).then(() => {
            console.log('New Tour has been added');
        })
        .catch((error) => {
            console.log("Create Tour failed", error);
            Promise.reject(error);
        })
}

export const getTour = (documentId) => {

    return Tours
        .doc(documentId)
        .get()
        .then(documentSnapshot => {
            if (documentSnapshot.exists) {
                return documentSnapshot.data();
            }
        }).catch((error) => {
            Promise.reject(error);
        })
}


export const updateTour = (data) => {

    return Tours
        .doc(data.id)
        .update(data)
        .then(() => {
            console.log('success fully updated');
        })
        .catch((error) => {
            console.log('Error while updating the tour', error);
            Promise.reject(error);
        })
}
export const deleteTour = (doc) => {

    return Tours
        .doc(doc)
        .delete()
        .then(() => {
            console.log("Document successfully deleted!");
        })
        .catch((error) => {
            console.error("Error removing document: ", error);
            Promise.reject(error);
        });
};

export default TourService
